<template>
    <div class="uploads" v-if="isMounted && isAccessPermissions">
        <div class="flex justify-between items-center uploads_mode">
            <div class="flex">
                <vs-checkbox
                  v-if="!isNotFalconPermissions"
                  :disabled="isAccessFalconPermissions || (isResend || activeTab !== 'uploads' || isDisabledFalconCheckbox) || isRecycle"
                  class="m-0 p-2"
                  v-model="isFalcon"
                >Falcon</vs-checkbox>

                <vs-checkbox
                  v-if="!isNotRecyclePermissions"
                  :disabled="isAccessRecyclePermissions || (isResend || activeTab !== 'uploads' || isDisabledRecycleCheckbox) || isFalcon"
                  class="m-0 p-2"
                  v-model="isRecycle"
                >Recycle</vs-checkbox>
            </div>

            <div class="flex items-center" v-if="isRecycle">
                <vs-button
                  v-tooltip="$t('buttons.DownloadTemplate')"
                  class="mr-3"
                  color="primary"
                  v-bind="$iconData('icon-file', 'fi-rr-file')"
                  @click="generateRecycleTemplateCSV"
                />
            </div>
        </div>

        <vs-row v-if="activeTab === 'uploads'" :class="{upload__disabled: isResend}">
            <vs-col
                class="p-2"
                vs-w="12"
                vs-sm="12"
                :vs-lg="files.length ? 6 : 12"
                vs-xs="12"
            >
                <v-upload
                    class="uploads__upload"
                    :error="errorMessage"
                    :disabled="isResend"
                    @error="setError"
                    @result="resultCSV"
                ></v-upload>
            </vs-col>

            <vs-col
                class="p-2"
                vs-w="12"
                vs-sm="12"
                vs-lg="6"
                vs-xs="12"
            >
                <vs-card class="uploads__block shadow-none">
                    <div
                        class="uploads__info p-2"
                        :class="{'uploads__active': activeViewIndex === index}"
                        v-for="(file, index) of files"
                        :key="index"
                    >
                        <vs-checkbox
                            class="m-0"
                            v-if="(file.isFalcon || file.isRecycle) && !file.is_force_hold"
                            v-model="file.isFalcon || file.isRecycle"
                            :disabled="file.isFalcon || file.isRecycle"
                        >{{ getCapitalizedNameFromIsKey(file) }}</vs-checkbox>

                        <vs-checkbox
                            class="m-0"
                            v-if="!(file.isFalcon || file.isRecycle)"
                            v-model="file.is_force_hold"
                        >Send to hold</vs-checkbox>

                        <vs-divider class="mt-2 mb-2"/>
                        <div class="flex items-center justify-between">
                            <div class="flex items-center">
                                <vs-icon color="primary" size="small" v-bind="$iconData('icon-upload-cloud', 'fi-rr-cloud-upload')"/>
                                <div class="ml-4">CSV</div>
                                <div class="ml-4">
                                    <div class="uploads__info-title">{{file.file.name}}</div>
                                    <div class="text-xs camp-ident">Размер {{ bytesToMegabytes(file.file.size) }}</div>
                                </div>
                            </div>
                            <div class="flex">
                                <vs-button
                                    v-tooltip="$t('tooltip.upload')"
                                    v-if="!(file.isFalcon || file.isRecycle)"
                                    class="mr-1"
                                    radius
                                    color="primary"
                                    type="flat"
                                    :disabled="isResend"
                                    v-bind="$iconData('icon-upload', 'fi-rr-upload')"
                                    @click="uploadCSV(file, index)"
                                ></vs-button>
                                <vs-button
                                    v-tooltip="$t('tooltip.view')"
                                    class="mr-1"
                                    radius
                                    color="primary"
                                    type="flat"
                                    v-bind="$iconData('icon-eye', 'fi-rr-eye')"
                                    :disabled="activeViewIndex === index || isResend"
                                    @click="previewCSV(file, index)"
                                ></vs-button>
                                <vs-button
                                    v-tooltip="$t('tooltip.remove')"
                                    radius
                                    color="danger"
                                    type="flat"
                                    :disabled="isResend"
                                    v-bind="$iconData('icon-x', 'fi-rr-circle-xmark')"
                                    @click="removeCSV(index)"
                                ></vs-button>
                            </div>
                        </div>
                    </div>
                </vs-card>
            </vs-col>
        </vs-row>

        <ds-filter
            class="mt-6"
            ssr
            v-if="activeTab === 'status'"
            :fields="filterFields"
            :data="filters.options"
            :loader="loaders.filter"
            @resetFilter="refreshFilter"
            @submit="submitFilter"
        >
            <vs-col
                vs-w="12"
                vs-sm="6"
                vs-lg="3"
                vs-xs="12"
            >
                <div class="m-2">
                    <label class="text-sm opacity-75">{{$t('global.Send_date')}}</label>
                    <date-picker
                        direction="sent_date"
                        :date="date"
                        @select="changeDate"
                    ></date-picker>
                </div>
            </vs-col>
        </ds-filter>

        <div class="flex items-center justify-between" v-if="isFalcon || isRecycle">
            <ul class="uploads__tabs flex items-center">
                <li class="uploads__tab ml-2 mr-2"
                    v-for="(tab, index) of tabs"
                    v-if="isLeadUploadFalconPermissions"
                    :key="index"
                    :class="{
                                    'uploads__tab--active': tab.event === activeTab,
                                    'cursor-pointer': tab.event !== activeTab,
                                    'uploads__tab--disabled': isResend
                                }"
                    @click="changeTab(tab.event)"
                >{{$t(tab.name)}}</li>
            </ul>

            <div class="flex items-center" v-if="activeTab === 'status'">
                <ul class="uploads__triggers mr-1">
                    <c-loader
                        v-if="isErrorLoader"
                        color="rgba(var(--vs-primary), 1)"
                    ></c-loader>
                    <li v-for="(trigger, ind) of selectTriggers"
                        :key="ind"
                        :class="{
                            'uploads__triggers--disabled': !trigger.is
                        }"
                        @click="changeLeadsByTrigger(trigger.name)"
                    >
                        {{trigger.name}}
                    </li>
                </ul>

                <vs-chip class="mr-1 mb-0">{{errorsCount}}</vs-chip>

                <vs-button v-tooltip="$t('tooltip.Resend')" v-can="'lead_upload_falcon.access'" class="mr-1" radius color="primary" type="flat" :disabled="!selectedIds.length" v-bind="$iconData('icon-corner-down-left', 'fi-rr-arrow-turn-down-left')" @click="resendLeads"></vs-button>
                <vs-button v-tooltip="$t('tooltip.Delete')" v-can="'lead_upload_falcon.destroy'" class="mr-1" radius color="danger" type="flat" v-bind="$iconData('icon-trash-2', 'fi-rr-trash')" @click="removeFalconLeads"></vs-button>
            </div>

            <div class="flex items-center" v-if="activeTab === 'uploads'">
                <vs-button v-if="isResend" v-tooltip="$t('global.Cancel')" v-can="'lead_upload_falcon.access'" class="mr-1" radius color="danger" type="flat" v-bind="$iconData('icon-x', 'fi-rr-circle-xmark')" @click="resendCancel"></vs-button>
            </div>
        </div>

        <vs-card class="shadow-none relative card mt-6" v-if="activeTab === 'uploads' && isFalcon || isRecycle">
            <div v-if="loaders.action" class="flex justify-center">
                <c-loader color="rgba(var(--vs-primary), 1)" />
            </div>

            <vs-row v-else vs-type="flex" vs-align="end">
                <vs-col
                    v-if="isFalcon"
                    vs-w="12"
                    vs-sm="12"
                    vs-lg="12"
                    vs-xs="12"
                >
                    <div class="m-2">
                        <div class="flex">
                            <vs-checkbox v-model="ignore">{{$t('global.Straight')}}</vs-checkbox>
                        </div>
                    </div>
                </vs-col>

                <vs-col
                    vs-w="12"
                    vs-sm="6"
                    vs-lg="3"
                    vs-xs="12"
                    v-for="(item, index) of parameters"
                    :key="index"
                >
                    <div class="m-2">
                        <label class="text-sm opacity-75">{{$t(item.name)}}</label>
                        <v-select
                            :options="params[item.key]"
                            :reduce="a => a.id"
                            label="name"
                            :placeholder="$t(item.name)"
                            :clearable="false"
                            v-model="selectParams[item.send]"
                            @input="selectData(item, $event)"
                        />
                    </div>
                </vs-col>

                <vs-col
                    vs-w="6"
                    vs-sm="3"
                    vs-lg="2"
                    vs-xs="6"
                >
                    <div class="m-2">
                        <label class="text-sm opacity-75">Per time</label>
                        <input
                            name="delay"
                            class="input-delay"
                            :disabled="ignore"
                            :value="leads_per_time"
                            @input="validation('leads_per_time', $event, false, 1, 50)"
                            @blur="validation('leads_per_time', $event, true, 1, 50)"
                            @keypress="validationPress"
                        />
                    </div>
                </vs-col>

                <vs-col
                    vs-w="6"
                    vs-sm="3"
                    vs-lg="1"
                    vs-xs="6"
                >
                    <div class="m-2">
                        <label class="text-sm opacity-75">Delay</label>
                        <input
                            name="delay"
                            class="input-delay"
                            :disabled="ignore"
                            :value="delay"
                            @input="validation('delay', $event, false)"
                            @blur="validation('delay', $event, true)"
                            @keypress="validationPress"
                        />
                    </div>
                </vs-col>

                <vs-col
                    vs-w="12"
                    vs-sm="6"
                    vs-lg="3"
                    vs-xs="12"
                >
                    <div class="m-2">
                        <label class="text-sm opacity-75"></label>
                        <vs-button
                            class="w-full"
                            color="primary"
                            type="filled"
                            :disabled="!table.data.length"
                            v-bind="$iconData('icon-upload', 'fi-rr-upload')"
                            @click="uploadCSV(files[activeViewIndex], activeViewIndex)"
                        >{{ $t('tooltip.upload') }}</vs-button>
                    </div>
                </vs-col>
            </vs-row>
        </vs-card>

        <div v-if="loaders.tabs" class="flex justify-center">
            <c-loader color="rgba(var(--vs-primary), 1)" />
        </div>

        <ds-table
            ref="table"
            class="mt-6"
            :ssr="(isFalcon || isRecycle) && (activeTab === 'status' || isResend)"
            :view-items="[10, 15, 20]"
            :total="(isFalcon || isRecycle) && (activeTab === 'status' || isResend) ? table.totalNum : dataFilter.length"
            v-if="table.data.length || dataFilter.length"
            :data="(activeTab === 'status' || isResend) ? dataFilter : table.data"
            :heads="(activeTab === 'status' || isResend) ? leadsStatusTable.headers : table.headers"
            :select="(isFalcon || isRecycle) && (activeTab === 'status')"
            :disabled="table.loader"
            :page="table.pageNum"
            select-key="id"
            disabled-select
            @page="page"
            @limit="limit"
            @sort="sort"
            @selected="selectedTable"
        >
            <template v-slot:advertiser_response="{advertiser_response}">
                <div v-if="advertiser_response.advertiser_response" class="flex items-center">
                    <vs-icon v-bind="$iconData('icon-alert-circle', 'fi-rr-circle-exclamation-check')" color="red"></vs-icon>
                    <div>
                        <div class="whitespace-no-wrap ml-2 textOverflow statusErrorsText">{{ advertiser_response.advertiser_response }}</div>
                    </div>
                    <vs-icon
                        class="ml-2 cursor-pointer"
                        color="primary"
                        v-tooltip="$t('tooltip.Copy')"
                        @click.stop.prevent="copy(advertiser_response.advertiser_response)"
                        v-bind="$iconData('icon-copy', 'fi-rr-copy-alt')"
                    />
                    <vs-icon
                        v-if="advertiser_response.advertiser_response && advertiser_response.advertiser_response.length >= 35"
                        class="ml-2 cursor-pointer"
                        color="primary"
                        @click.stop.prevent="errorStatusInfo(advertiser_response.advertiser_response)"
                        v-bind="$iconData('icon-eye', 'fi-rr-eye')"
                    />
                </div>
                <div v-else>-</div>
            </template>
        </ds-table>

        <no-data
            class="mt-6"
            v-if="!dataFilter.length && activeTab === 'status' && !loaders.tabs"
        />
    </div>
</template>

<script>
import VUpload from "@/components/Upload.vue"
import {checkPermission, dateParse, utils} from '@/utils/mixins'
import send from "@/utils/fetch"
import ErrorHandler from "@/utils/errorHandler"
import vSelect from "vue-select"
import {copy} from "@/utils/utils"
import EventBus from "@/store/eventBus"
import qs from "qs"

export default {
    data() {
        return {
            isMounted: false,
            isFalcon: false,
            isRecycle: false,
            isResend: false,
            isErrorLoader: false,
            ignore: false,
            isDisabledFalconCheckbox: false,
            isDisabledRecycleCheckbox: false,
            activeViewIndex: 0,
            selectedLeads: [],
            table: {
                headers: [],
                data: [],
                totalNum: 1,
                pageNum: 1,
                limitNum: 10,
                loader: false
            },
            leadsStatusTable: {
                headers: [],
                data: [],
                filterData: [],
            },
            date: {
                startDate: new Date(),
                endDate: new Date()
            },
            selectDate: {
                start: new Date(),
                end: new Date(),
                direction: 'sent_date'
            },
            files: [],
            errorMessage: '',
            filterFields: [
                {name: 'table_filters.advertiser_id', type: 'select', label: 'advertiser_name', field: 'advertisers', multiple: false},
                {name: 'table_filters.advertiser_integration_id', type: 'select', label: 'advertiser_integration_name', field: 'integrations', multiple: false},
                {name: 'table_filters.country', type: 'select', label: 'country', field: 'countries', multiple: false},
            ],
            selectParams: {
                advertiser_id: null,
                advertiser_integration_id: null,
                affiliate_id: null,
                team_id: null
            },
            selectTriggers: [
                {name: 'error', is: false},
            ],
            activeTab: 'uploads',
            delay: '1',
            leads_per_time: '1',
            selectedIds: [],
            params: {
                falcon: {},
                recycle: {}
            },
            allData: {
                affiliates: [],
                integrations: []
            },
            loaders: {
                tabs: true,
                filter: false,
                action: false
            },
            orderBy: {},
            errorsCount: 0,
            filters: {
                options: {},
                selected: {}
            }
        }
    },

    mixins: [utils, dateParse, checkPermission],

    components: {VUpload, vSelect},

    computed: {
        parameters() {
            const params = [
                {name: 'global.Advertiser', key: 'advertisers', send: 'advertiser_id'},
                {name: 'global.Integration', key: 'integrations', send: 'advertiser_integration_id'}
            ]

            if (this.isRecycle) {
                params.push(
                    {name: 'global.Team', key: 'teams', send: 'team_id'},
                    {name: 'global.Affiliate', key: 'affiliates', send: 'affiliate_id'},
                )
            }

            return params
        },

        tabs() {
            return [
                {
                    name: 'global.uploadsLeads',
                    event: 'uploads'
                },
                {
                    name: 'global.statusLeads',
                    event: 'status',
                    disabled: true
                }
            ]
        },

        isEmptyTable() {
            return !this.table.headers.length || !this.leadsStatusTable.headers.length
        },

        dataFilter() {
            return this.leadsStatusTable.filterData.length ? this.leadsStatusTable.filterData : this.leadsStatusTable.data
        },

        headerValidation() {
            const data = {
                campaign: [
                    'email',
                    'phone',
                    'campaign_identifier',
                    'last_name',
                    'first_name',
                    'language',
                    'landing_url',
                    'sub1'
                ],
                not_campaign: [
                    'email',
                    'phone',
                    'user_id',
                    'last_name',
                    'first_name',
                    'language',
                    'landing_url',
                    'sub1',
                    'land_id'
                ],
                falcon: [
                    'firstName',
                    'lastName',
                    'phone',
                    'email',
                    'country',
                    'language',
                    'currency',
                    'password',
                    'source',
                    'referral'
                ],
                recycle: [
                    'first_name',
                    'last_name',
                    'phone',
                    'email',
                    'country',
                    'language',
                    'ip',
                    'landing_name',
                    'landing_url',
                    'offer_name',
                    'offer_id',
                    'geo',
                    'mapping_geo',
                    'campaign_id',
                    'campaign_identifier'
                ]
            }

            if (this.isAccessFalconPermissions) {
                delete data.campaign
                delete data.not_campaign
            } else if (this.isNotFalconPermissions) {
                delete data.falcon
            }

            return data
        },

        isAccessPermissions() {
            return this.isPermission('uploads.access') || this.isPermission('uploads_falcon.access')
        },

        isAccessFalconPermissions() {
            return !this.isPermission('uploads.access') && this.isPermission('uploads_falcon.access')
        },

        isAccessRecyclePermissions() {
            return !this.isPermission('uploads.access') && this.isPermission('uploads_recycle.access')
        },

        isFalconPermissions() {
            return this.isPermission('uploads_falcon.access')
        },

        isRecyclePermissions() {
            return this.isPermission('uploads_falcon.access')
        },

        isNotFalconPermissions() {
            return this.isPermission('uploads.access') && !this.isPermission('uploads_falcon.access')
        },

        isNotRecyclePermissions() {
            return this.isPermission('uploads.access') && !this.isPermission('uploads_recycle.access')
        },

        isLeadUploadFalconPermissions() {
            return this.isPermission('lead_upload_falcon.access')
        }
    },

    watch: {
        'table.data'(value) {
            this.isDisabledRecycleCheckbox = this.isDisabledFalconCheckbox = !!value.length
        },

        isFalcon(value) {
            if (value) {
                this.getAdvertiserIntegration()
            }
        },

        isRecycle(value) {
            if (value) {
                this.getRecycleData()
            }
        }
    },

    methods: {
        getCapitalizedNameFromIsKey(obj) {
            const isKey = Object.keys(obj).find(key => key.startsWith('is'))

            if (!isKey) {
                return null
            }

            const name = isKey.slice(2)
            return `${name.charAt(0).toUpperCase()}${name.slice(1)}`
        },

        copyData(data) {
            return JSON.parse(JSON.stringify(data))
        },

        async submitFilter(data) {
            this.filters.selected = this.copyData(data)
            this.selectedIds = []

            if (this.table.pageNum !== 1) {
                await this.page(1)
            } else {
                await this.getFalconLeads()
            }
        },

        async sort(sort) {
            this.orderBy =  {
                name: sort.name,
                direction: sort.type
            }

            await this.getFalconLeads(true)
        },

        async page(page) {
            if (this.table.pageNum !== page) {
                this.table.pageNum = page

                if (this.isResend) {
                    await this.getLeadsByResend()
                } else {
                    await this.getFalconLeads(true)
                }
            }
        },

        async limit(limit) {
            if (limit !== this.table.limitNum) {
                this.table.limitNum = limit

                if (this.table.pageNum !== 1) {
                    await this.page(1)
                } else {
                    this.isResend ? this.getLeadsByResend() : await this.getFalconLeads(true)
                }
            }
        },

        copy(data) {
            if (data) {
                copy(data)

                const icon = this.$iconData('icon-check', 'fi-rr-check')
                this.$vs.notify({
                    time: 18000,
                    title: 'Success!',
                    text: this.$t('notification.success'),
                    color: 'success',
                    iconPack: icon['icon-pack'],
                    icon: icon.icon
                })
            }
        },

        errorStatusInfo(data) {
            EventBus.$emit('emitPopupEvent', {type: 'errorStatusInfo', name: this.$t('statistic.ERR_Status'), data: data})
        },

        async refreshFilter() {
            this.selectDate.start = new Date()
            this.selectDate.end = new Date()
            this.date.startDate = new Date()
            this.date.endDate = new Date()

            this.filters.selected = {}

            await this.getFalconLeads()

            this.leadsStatusTable.filterData = data
            this.selectedIds = []
            this.selectedLeads = []

            if (this.$refs.table) {
                this.$refs.table.clearSelect()
            }
        },

        async changeLeadsByTrigger(name) {
            await this.getErrorsLeads()
        },

        resendCancel() {
            this.isResend = false
            this.selectedIds = []
            this.selectedLeads = []

            this.table.headers = []
            this.table.data = []

            this.leadsStatusTable.headers = []
            this.leadsStatusTable.data = []
            this.leadsStatusTable.filterData = []

            if (this.$refs.table) {
                this.$refs.table.clearSelect()
            }

            if (this.files[0]) {
                this.previewCSV(this.files[0], 0)
            }
        },

        validation(key, event, bool, min = 1, max = 10) {
            const num = +event.target.value

            if (bool && !num) {
                event.target.value = min.toString()
                this[key] = min.toString()

                return
            }

            if (Math.sign(num) === -1) {
                event.target.value = min.toString()
            }

            if (num > max) {
                event.target.value = max.toString()
            }

            this[key] = event.target.value.toString()
        },

        validationPress(event) {
            if (!/^[0-9]$/.test(event.key)) {
                event.preventDefault()
            }
        },

        mutationAdvInt(data) {
            return data.reduce((res, item) => {
                const addIfNotExists = (collection, key, name, additionalProps = {}) => {
                    const existingItem = collection.find(adv => adv.id === item[key])

                    if (!existingItem) {
                        collection.push({
                            id: item[key],
                            name: item[name],
                            ...additionalProps
                        })
                    }
                }

                addIfNotExists(res.advertisers, 'advertiser_id', this.isPermission('settings_advertiser.show_advertiser_name') ? 'advertiser_name' : 'advertiser_id')
                addIfNotExists(res.integrations, 'advertiser_integration_id', 'advertiser_integration_name', {
                    advertiser_id: item.advertiser_id
                })

                return res
            }, {
                advertisers: [],
                integrations: []
            })
        },

        selectData(item, event) {
            const { key: name } = item

            const relations = {
                advertisers: ['advertiser_id', 'integrations', 'advertiser_integration_id'],
                teams: ['team_id', 'affiliates', 'affiliate_id']
            }

            const relation = relations[name]
            if (relation) {
                const [idKey, dataKey, selectKey] = relation

                const params = this.findDataById(event, this.allData[dataKey], idKey)

                this.params[dataKey] = params
                this.selectParams[selectKey] = params.length > 0 ? params[0].id : null
            }
        },

        async changeDate(data) {
            this.selectDate.start = data.startDate
            this.selectDate.end = data.endDate
            this.selectDate.directionend = data.directionend
        },

        async changeTab(event) {
            const isStatus = event === 'status'

            if (!this.isResend) {
                this.table.headers = []
                this.table.data = []

                this.leadsStatusTable.headers = []
                this.leadsStatusTable.data = []
                this.leadsStatusTable.filterData = []
            }

            if (this.isResend && !isStatus) {
                this.table.pageNum = 1

                await this.getLeadsByResend()

                this.table.totalNum = this.selectedIds.length || 0
            } else if (isStatus && !this.isResend) {
                await this.getFalconLeads()
            } else {
                if (this.files[0]) {
                    this.previewCSV(this.files[0], 0)
                }
            }

            this.activeTab = event
        },

        selectedTable(ids) {
            this.selectedIds = ids
        },

        checkUniqueStrings(array) {
            return new Set(array).size === array.length;
        },

        resultCSV(files) {
            const file = files[0]
            const reader = new FileReader()

            reader.onload = (event) => {
                const csvContent = event.target.result
                const headers = this.getHeader(csvContent).split(/[,;]/)
                const validate = this.headerValidationCSV(headers)

                if (validate) {
                    if (!this.checkUniqueStrings(headers)) {
                        this.setError(this.$t('upload.notValidUniqueFields'))
                        return
                    }

                    const param = {
                        file,
                        [`is${validate.type[0].toUpperCase() + validate.type.slice(1)}`]: true,
                    }

                    this.files.push(param)

                    if (this.files.length === 1) {
                        this.previewCSV(param, 0)
                    }

                    this.setError('')
                } else {
                    this.setError(this.$t('upload.notValidFields'))
                }
            }

            reader.readAsText(file)
        },

        setError(message) {
            this.errorMessage = message
        },

        removeEmptyObjects(arr) {
            return arr.filter(obj => {
                if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
                    return Object.values(obj).some(value => value !== null && value !== undefined && value !== '')
                }
                return true
            })
        },

        setDataToTable(data) {
            this.table.headers = data.headers
            this.table.data = this.removeEmptyObjects(data.data)
        },

        createTableHeader(data, isSortKey = true) {
            return Object.keys(data).map(key => {
                const params = {
                    name: key,
                    key: key,
                    value: key,
                    display: true,
                    translate: 'none'
                }

                const exclude = [
                    'advertiser_integration_name',
                    'advertiser_name',
                    'password'
                ]

                if (isSortKey && !exclude.includes(key)) params.sortKey = key

                return params
            })
        },

        defineCSVType(keys = []) {
            for (const [key, array] of Object.entries(this.headerValidation)) {
                if (array.every(item => keys.includes(item))) {
                    return key
                }
            }
            return ''
        },

        headerValidationCSV(header) {
            const csvType = this.defineCSVType(header)

            if (csvType) {
                const keys = this.headerValidation[csvType]
                return {
                    type: csvType,
                    isValid: header.every(key => keys.includes(key))
                }
            }
        },

        previewCSV(file, index) {
            const reader = new FileReader()

            reader.onload = (event) => {
                const csvContent = event.target.result
                const array = this.parseCSVToArray(csvContent)

                const headers = this.createTableHeader(array[0])
                const data = array

                this.setDataToTable({headers, data, index})

                this.activeViewIndex = index
            }

            const propertyName = Object.keys(file).find(key => key.startsWith('is')) || null
            if (propertyName) {
                this[propertyName] = file[propertyName]
            }

            this.isFalcon = this.isDisabledFalconCheckbox = propertyName === 'isFalcon'
            this.isRecycle = this.isDisabledRecycleCheckbox = propertyName === 'isRecycle'

            reader.readAsText(file.file)

            this.loaders.tabs = false
        },

        removeCSV(index) {
            this.files = this.files.slice(0, index).concat(this.files.slice(index + 1))

            if (this.activeViewIndex === index || !this.files.length) {
                this.table.headers = []
                this.table.data = []

                if (this.files[0]) {
                    this.previewCSV(this.files[0], 0)
                }
            }
        },

        async getErrorsLeads() {
            try {
                this.isErrorLoader = true
                const params = {
                    start: this.dateParse(this.selectDate.start),
                    end: this.dateParse(this.selectDate.end),
                    direction: this.selectDate.direction,
                    filters: this.filters.selected
                }

                this.selectedIds = await send($url.upload["lead-upload-falcon_error"], 'GET', {
                    params,
                    paramsSerializer: params => qs.stringify(params, {
                        encode: false,
                        indices: false,
                        arrayFormat: 'brackets',
                    })
                }).then(response => response.data.result.ids)

                if (this.$refs.table) {
                    this.$refs.table.setSelect(this.selectedIds)
                }
            } catch (e) {
                new ErrorHandler(e).send
            } finally {
                this.isErrorLoader = false
            }
        },

        async getCountErrors(params) {
            const response = await send($url.upload["lead-upload-falcon_error_count"], 'GET', {
                params: {
                    start: params.start,
                    end: params.end,
                    direction: params.direction,
                    filters: params.filters
                },
                paramsSerializer: params => qs.stringify(params, {
                    encode: false,
                    indices: false,
                    arrayFormat: 'brackets',
                })
            })
                .then(response => response.data.result.total)

            return response
        },

        async getFalconLeads(tableLoader = false) {
            try {
                if (tableLoader) {
                    this.table.loader = true
                } else {
                    this.loaders.tabs = true
                }

                // this.selectedIds = []
                // if (this.$refs.table) {
                //     this.$refs.table.clearSelect()
                // }

                const template = {
                    advertisers: 'advertiser_id',
                    countries: 'country',
                    integrations: 'advertiser_integration_id'
                }

                const params = {
                    start: this.dateParse(this.selectDate.start),
                    end: this.dateParse(this.selectDate.end),
                    direction: this.selectDate.direction,
                    per_page: +this.table.limitNum,
                    page: +this.table.pageNum,
                    order_by: this.orderBy.name,
                    order_direction: this.orderBy.direction,
                    ...Object.fromEntries(Object.entries(this.filters.selected)
                        .map(([key, value]) => [template[key], value]))
                }

                if (!this.orderBy.direction) {
                    params.order_by = 'id'
                    params.order_direction = 'desc'
                }

                const [leads, count] = await Promise.all([
                    send($url.upload["lead-upload-falcon"], 'GET', {
                        params,
                        paramsSerializer: params => qs.stringify(params, {
                            encode: false,
                            indices: false,
                            arrayFormat: 'brackets',
                        })
                    }).then(response => response.data.result),

                    this.getCountErrors(params)
                ])

                this.filters.options = leads.filters
                this.filters.options.country = [...new Set(leads.filters.countries)]

                this.errorsCount = count || 0
                this.table.totalNum = leads.total

                if (leads.leads && !leads.leads.length) {
                    this.leadsStatusTable.headers = []
                    this.leadsStatusTable.data = []

                    return
                }

                const headers = leads.leads[0]

                if (headers) {
                    this.leadsStatusTable.headers = this.createTableHeader(headers)
                    this.leadsStatusTable.data = leads.leads

                    this.selectTriggers[0].is = (+this.errorsCount) !== 0
                } else {
                    this.selectTriggers = this.selectTriggers.map(item => {
                        item.is = false
                        return item
                    })
                }
            } catch (e) {
                new ErrorHandler(e).send
            } finally {
                this.loaders.tabs = false
                this.table.loader = false
            }
        },

        sliceResendData() {
            return this.copyData(this.selectedIds.sort((a, b) => a > b))
                .slice((this.table.pageNum - 1) * this.table.limitNum, (this.table.pageNum - 1) * this.table.limitNum + this.table.limitNum)
        },

        async getLeadsByResend() {
            try {
                this.table.loader = true
                const response = await send($url.upload["lead-upload-falcon_leads"], 'GET', {
                    params: {ids: this.sliceResendData()}
                }).then(response => response.data.result.leads)

                const headers = response[0]

                if (headers) {
                    this.leadsStatusTable.headers = this.createTableHeader(headers, false)
                    this.leadsStatusTable.data = response

                    this.selectTriggers[0].is = (+this.errorsCount) !== 0
                } else {
                    this.selectTriggers = this.selectTriggers.map(item => {
                        item.is = false
                        return item
                    })
                }
            } catch (e) {
                new ErrorHandler(e).send
            } finally {
                this.table.loader = false
            }
        },

        async resendLeads() {
            this.isResend = true

            await this.changeTab('uploads')

            this.activeViewIndex = null

            this.table.headers = this.leadsStatusTable.headers
            this.table.data = this.selectedIds
        },

        async removeFalconLeads() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: this.$t('confirm.Confirm_action'),
                text: this.$t('confirm.removeLeads'),
                accept: async () => {
                    try {
                        await send($url.upload["lead-upload-falcon_destroy"], 'DELETE')

                        await this.getFalconLeads()
                    } catch (e) {
                        new ErrorHandler(e).send
                    }
                },
                acceptText: this.$t('confirm.confirm'),
                cancelText: this.$t('global.Cancel')
            })
        },

        async uploadCSV(file, index) {
            if (this.isResend) {
                await send($url.upload["lead-upload-falcon_send"], 'POST', {
                    data: {
                        ids: this.selectedIds,
                        delay: +this.delay,
                        advertiser_integration_id: +this.selectParams.advertiser_integration_id,
                        leads_per_time: +this.leads_per_time,
                        ignore: this.ignore ? 1 : 0
                    }
                })

                this.resendCancel()
            } else {

                const formData = new FormData()
                formData.append('file', file.file)
                formData.append('is_force_hold', file.is_force_hold ? 1 : 0)

                let url = $url.upload.upload

                if (file.isFalcon) {
                    formData.append('advertiser_integration_id', +this.selectParams.advertiser_integration_id)
                    formData.append('delay', +this.delay)
                    formData.append('leads_per_time', +this.leads_per_time)
                    formData.append('ignore', this.ignore ? 1 : 0)

                    url = $url.upload['upload-falcon']
                }

                if (file.isRecycle) {
                    formData.append('advertiser_integration_id', +this.selectParams.advertiser_integration_id)
                    formData.append('team_id', +this.selectParams.team_id)
                    formData.append('affiliate_id', +this.selectParams.affiliate_id)
                    formData.append('delay', +this.delay)
                    formData.append('leads_per_time', +this.leads_per_time)

                    url = $url.upload['upload-recycle']
                }

                try {
                    await send(
                        url,
                        'POST',
                        {
                            data: formData,
                            headers: {'Content-Type': 'multipart/form-data'}
                        }
                    )

                    this.removeCSV(index)

                    this.ignore = false
                } catch (e) {
                    new ErrorHandler(e).send
                }
            }
        },

        findDataById(id, data = [], name = 'advertiser_id') {
            return data.filter(item => item[name] === id)
        },

        defaultSelectParam(data, action) {
            if (action === 'recycle') {
                this.selectParams.team_id = data.teams[0].id
                this.selectParams.advertiser_id = data.advertisers[0].id

                const affiliates = this.findDataById(this.selectParams.team_id, data.affiliates, 'team_id')
                const integrations = this.findDataById(this.selectParams.advertiser_id, data.integrations)

                this.selectParams.affiliate_id = affiliates[0].id
                this.selectParams.advertiser_integration_id = integrations[0].id
            } else {
                this.selectParams.advertiser_id = data.advertisers[0].id

                const integrations = this.findDataById(this.selectParams.advertiser_id, data.integrations)
                this.selectParams.advertiser_integration_id = integrations[0].id
            }
        },

        async getRecycleData() {
            try {
                this.loaders.action = true

                const response = await send($url.recycle.getRecycleDataForUpload, 'GET')
                    .then(response => response.data.result)
                    .then(response => ({
                        ...response,
                        ...this.mutationAdvInt(response.advertisers)
                    }))

                this.allData = {
                    affiliates: response.affiliates,
                    integrations: response.integrations
                }

                this.defaultSelectParam(response, 'recycle')

                this.params = {
                    ...response,
                    integrations: this.findDataById(this.selectParams.advertiser_id, response.integrations),
                    affiliates: this.findDataById(this.selectParams.team_id, response.affiliates, 'team_id')
                }
            } catch (e) {
                new ErrorHandler(e).send()
            } finally {
                this.loaders.action = false
            }
        },

        async getAdvertiserIntegration() {
            try {
                this.loaders.action = true

                const params = await send($url.advrtsr_integration.falcon, 'GET')
                    .then(response => this.mutationAdvInt(response.data.result))

                this.allData = {
                    integrations: params.integrations
                }

                this.defaultSelectParam(params)

                this.params = {
                    ...params,
                    integrations: this.findDataById(this.selectParams.advertiser_id, params.integrations)
                }
            } catch (e) {
                new ErrorHandler(e).send
            } finally {
                this.loaders.action = false
            }
        },

        generateRecycleTemplateCSV() {
            const rows = [
                [
                    'first_name',
                    'last_name',
                    'phone',
                    'email',
                    'country',
                    'language',
                    'ip',
                    'landing_name',
                    'landing_url',
                    'offer_name',
                    'offer_id',
                    'geo',
                    'mapping_geo',
                    'campaign_id',
                    'campaign_identifier'
                ],
                [
                    'first_name',
                    'last_name',
                    '46706884166',
                    'test@mail.com',
                    'EN',
                    'SE',
                    '105.20.116.180',
                    'custum',
                    'custum',
                    'custum',
                    '1',
                    'T1 (ENG)',
                    '{"SE":"EN"}',
                    '1',
                    '59066b54c3201a9afd3cccc368debcef'
                ]
            ]

            const csvContent = rows.map(e => e.join(',')).join('\n')
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
            const url = URL.createObjectURL(blob)

            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'recycle-uploads-template.csv')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            URL.revokeObjectURL(url)
        }
    },

    async mounted() {
        if (this.isAccessFalconPermissions) {
            this.isFalcon = true
        }

        this.loaders.tabs = false
        this.isMounted = true
    }
}
</script>

<style lang="scss">
@mixin disabled {
    opacity: .5;
    cursor: default;
    pointer-events: none;
}

.uploads {
    &__mode {
      height: 40px;
    }

    &__info-title {
        display: block;
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        max-width: 100%;
    }

    &__info {
        font-size: 15px;
        background-color: rgba(var(--vs-bodyBg), 1);
        border-radius: 6px;
        margin-bottom: 10px;
        &:last-child {
            margin-bottom: 0;
        }
    }

    &__active {
        box-shadow: 0 0 0 1px rgba(var(--vs-primary), .5);
    }

    &__tabs {

    }

    &__triggers {
        display: flex;

        li {
            padding: 5px 10px;
            background-color: white;
            cursor: pointer;
            text-transform: uppercase;

            &:first-child {
                border-top-left-radius: 6px;
                border-bottom-left-radius: 6px;
            }

            &:last-child {
                border-top-right-radius: 6px;
                border-bottom-right-radius: 6px;
            }

            &:hover {
                background-color: rgba(var(--vs-primary), 1);
                color: white;

                transition: background-color .20s ease;
            }
        }

        &--disabled {
            @include disabled
        }
    }

    &__disabled {
        .upload {
            @include disabled
        }
    }

    &__tab {
        padding: 10px;
        background-color: #fff;
        border-radius: 6px;
        min-width: 100px;
        text-align: center;

        &--active {
            background-color: rgba(var(--vs-primary), 1);
            color: white;
        }

        &--disabled {
            @include disabled
        }
    }

    .input-delay {
        border-radius: 4px;
        border: 1px solid rgba(60, 60, 60, 0.26);
        width: 100%;
        padding: {
            left: 8px;
            right: 8px;
        };
        height: 37.78px;
    }

    .vs-card--content {
        font-size: inherit;
    }

    .statusErrorsText {
        max-width: 250px;
        text-overflow: ellipsis;
        overflow: hidden;
    }
}
</style>
